import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './components/app/App';

import Footer from './components/Footer';
import { HistoryContextProvider } from './context/HistoryContext';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HistoryContextProvider>
      <App />
    </HistoryContextProvider>
    <Footer />
  </React.StrictMode>
);
